import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useLocation } from 'react-router-dom';
import { EXAM_MODULE_HOME, EXAM_REGISTRATION } from '../../shared/Routes';
import { NPS_PATH } from '../../shared/Constants';

const LanguageDropdown = ({ className }: { className?: string }) => {
	const { i18n } = useTranslation();
	const location = useLocation();
	const onlyEnglish =
		location.pathname.includes(NPS_PATH) ||
		location.pathname.includes(EXAM_MODULE_HOME) ||
		location.pathname.includes(EXAM_REGISTRATION);

	const options = [
		{ value: 'en', label: 'English' },
		{ value: 'hi', label: 'हिन्दी' },
		{ value: 'ta', label: 'தமிழ்' },
		{ value: 'te', label: 'తెలుగు' },
		{ value: 'ka', label: 'ಕನ್ನಡ' },
		{ value: 'ma', label: 'മലയാളം' },
	];

	if (onlyEnglish) {
		options.pop();
	}

	const handleChange = (value: string) => {
		void i18n.changeLanguage(value);
	};

	return (
		<Select
			defaultValue="en"
			value={i18n.language}
			onChange={handleChange}
			className={className}
			options={options}
		/>
	);
};

export default LanguageDropdown;
